/**
 * Mirrors the post-media sizing used by Paçoca Native: portrait and square
 * videos occupy a square card in the feed, while landscape videos retain
 * their natural aspect ratio.
 */
export function getPostVideoAspectRatio(width: number, height: number): number {
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
        return 1;
    }

    const ratio = width / height;
    return ratio > 1 ? ratio : 1;
}
